module.exports = __webpack_public_path__ + "img/BatInduG.35690e66.png";